module.exports = __webpack_public_path__ + "static/media/bowling-Kiwi2020.3a19d0ef.jpg";